import { Typography, Select, IconButton, Box, SelectChangeEvent, MenuItem } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { StyledFormControl } from '../ExamSessions.styled';

type EnhancedPaginationProps = {
  totalRows: number;
  currentPage: number;
  totalPages: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (event: SelectChangeEvent<number>) => void;
};

const EnhancedPagination = ({
  totalRows,
  currentPage,
  totalPages,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}: EnhancedPaginationProps) => {
  const from = totalPages === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
  const to = currentPage !== totalPages ? currentPage * rowsPerPage : totalRows;

  return (
    <Box
      display='flex'
      alignItems='center'
      justifyContent='flex-end'
      sx={{ py: 1, px: 2, fontSize: 14, mt: 1, width: '100%' }}
    >
      <Typography variant='body2' sx={{ mr: 1 }}>
        Rows per page:
      </Typography>

      <StyledFormControl>
        <Select value={rowsPerPage} onChange={onRowsPerPageChange} size='small' variant='outlined'>
          {[20, 50, 100, 200].map((n) => (
            <MenuItem key={n} value={n}>
              {n}
            </MenuItem>
          ))}
        </Select>
      </StyledFormControl>

      <Typography variant='body2' sx={{ mr: 1 }}>
        {from}-{to} of {totalRows}
      </Typography>

      <IconButton
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        size='small'
      >
        <ArrowBackIosNewIcon fontSize='small' />
      </IconButton>

      <IconButton
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage >= totalPages}
        size='small'
      >
        <ArrowForwardIosIcon fontSize='small' />
      </IconButton>
    </Box>
  );
};

export default EnhancedPagination;
